import './App.css';
import Navbar from './components/Navbar/Navbar.js';
import { useState, useEffect, useCallback } from 'react';
import Home from './components/Home/Home';
import { Route, Routes, Navigate, useNavigate } from 'react-router-dom';
import UploadedDocs from './components/UploadedDocs/UploadedDocs';
import Suplier from './components/Suplier/Suplier';
import Docview from './components/Docview/Docview';
import Login from './components/Login/Login';
import SignUp from './components/SignUp/SignUp';
import PushQB from './components/PushQB/PushQB';
import axios from 'axios';
import { useAppConfig } from './AppConfigProvider.js';
import Settings from './components/Settings/Settings.js';
import Loader from './components/Loader/Loader';
import ForgotPassword from './components/Login/ForgotPassword';
import ResetPassword from './components/Login/ResetPassword';
import MyAccount from './components/MyAccount/MyAccount';
import DownloadManager from './components/DownloadManager/DownloadManager';


axios.defaults.withCredentials = true;

function App() {
  const [uId, setUId] = useState(null);
  const [fileBill, setFileBill] = useState(null);
  const [isImageUploaded, setIsImageUploaded] = useState({ isImage: false, isOcr: false });
  const [BillOCRDetails, setBillOCRDetails] = useState({});
  const [BillItems, setBillItems] = useState({});
  const [isFileTypeImg, setisFileTypeImg] = useState(false);
  const [fullVendorsList, setFullVendorsList] = useState({});
  const [isNewVendor, setIsNewVendor] = useState(true);
  const [isOCRVendor, setIsOCRVendor] = useState(true);
  const [OCRAddress, setOCRAddress] = useState(null);
  const [load, setLoad] = useState(false);
  const [currentSupplier, setCurrentSupplier] = useState({});
  const [activeVendor, setActiveVendor] = useState(null);
  const [activeVendorFull, setActiveVendorFull] = useState(null);
  const [session, setSession] = useState({ isLoggedIn: false, uId: null, roles: [], isLoading: true });

  const appConfig = useAppConfig();
  const userIDD = session.uId;
  const navigateN = useNavigate();
  //for delete item from item list UI
  const handleDelete = (itemNo) => {
    const newItems = BillItems.filter(BillItem => BillItem.itemNo !== itemNo);
    setBillItems(newItems);
    setBillOCRDetails(bill => ({ ...bill, billItems: newItems }));
    console.log("Item deleted");
  }

  //for add new item row
  const addTableRows = async (e) => {
    e.preventDefault();
    let expenseAccName;
    await axios.get(`${appConfig.backendUrl}api/v1/qbuser/expense-accounts/${userIDD}`)
      .then(response => {
        expenseAccName = response.data[0].expenseAccountName;
      });
    const NewBillItem = {
      itemNo: BillItems.length,
      itemName: '',
      productCode: '',
      quantity: '',
      unitPrice: '',
      price: '',
      expenseAccountName: expenseAccName
    }
    setBillItems([...BillItems, NewBillItem]);
    setBillOCRDetails(bill => ({ ...bill, billItems: [...BillItems, NewBillItem] }));
    console.log("New Item added", [...BillItems, NewBillItem]);
  }
  //for bill details change
  const onFormVChange = (e) => {
    setBillOCRDetails(bill => ({ ...bill, [e.target.name]: e.target.value }));
    console.log("updated BillOCRDetails: ", BillOCRDetails);
  }

  //for bill details change
  const onVendorChange = (e) => {
    axios.get(`${appConfig.backendUrl}api/v1/supplier/suppliers/${userIDD}`).then(function (response) {
      const matchingVendor = response.data.find(ex => ex.vendorName === e.target.value);

      if (matchingVendor) {
        setActiveVendorFull(matchingVendor);
        setIsNewVendor(false);
        console.log("e.target.value", e.target.value);
        console.log("IsNewVendor", isNewVendor);
      } else {
        setIsNewVendor(true);
        console.log("e.target.value", e.target.value);
        console.log("IsNewVendor", isNewVendor);
      }
    });

    let Vname = "";
    let Vaddress = "";
    let Crrncy = "";
    let VendorId = "";



    fullVendorsList.forEach((item) => {
      if (item.vendorName === e.target.value) {
        Vname = item.vendorName;
        Vaddress = item.vendorAddress;
        Crrncy = item.currency;
        VendorId = item.id;
        if (BillOCRDetails.vendorNameArray.includes(Vname)) {
          setIsOCRVendor(true);
          console.log("isOCRVendor", isOCRVendor);
        }
        else {
          setIsOCRVendor(false);
        }
      }
    });
    setBillOCRDetails(bill => ({ ...bill, vendorName: Vname }));
    setBillOCRDetails(bill => ({ ...bill, vendorAddress: Vaddress }));
    setBillOCRDetails(bill => ({ ...bill, currency: Crrncy }));
    setBillOCRDetails(bill => ({ ...bill, vendorId: VendorId }));
    setSelectedOption(Vname);
    setSelectedOptionAddress(Vaddress);
  }


  const [selectedOption, setSelectedOption] = useState(null);
  const _onChange = (ev, option) => {
    setSelectedOption(option);
    setBillOCRDetails(bill => ({ ...bill, vendorName: option }));
  }

  const [selectedOptionAddress, setSelectedOptionAddress] = useState(null);
  const _onChangeAddress = (ev, option) => {
    setSelectedOptionAddress(option);
    setBillOCRDetails(bill => ({ ...bill, vendorAddress: option }));
  }


  //for line items value change
  const onFormBillItemsValueChange = (e, itemBill) => {
    console.log("itemBill :", itemBill);
    console.log("e.target.value :", e.target.value);
    console.log("e.target :", e.target);
    const itemProperty = e.target.id;
    const NewDataBillItems = BillItems.map((item) => {
      if (item.itemNo === itemBill.itemNo) {
        item[itemProperty] = e.target.value;
        console.log("Filed Value change :", item[itemProperty]);
      }
      return item;
    });
    setBillItems(NewDataBillItems);
    setBillOCRDetails(bill => ({ ...bill, billItems: NewDataBillItems }));
    console.log("Bill Items after Filed Value change :", NewDataBillItems);
  }


  // function for supplier
  const SuplierRender = (supplier) => {
    setLoad(true);
    setTimeout(function () {
      setCurrentSupplier(supplier);
      setLoad(false);
    }, 500);
  }

  const fetchMe = useCallback(async () => {
    try {
      const response = await axios.get(`${appConfig.backendUrl}api/v1/auth/me`);
      console.log("Session fetched:", response.data);
      setSession({
        isLoggedIn: true,
        uId: response.data.id,
        roles: response.data.roles,
        isLoading: false
      });
      setUId(response.data.id);
    } catch (error) {
      console.error("Session fetch failed:", error);
      setSession({ isLoggedIn: false, uId: null, roles: [], isLoading: false });
    }
  }, [appConfig.backendUrl]);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  useEffect(() => {
    console.log("Current session state:", session);
  }, [session]);

  const logoutF = useCallback(() => {
    axios.post(appConfig.backendUrl + 'api/v1/auth/signout').finally(() => {
      setSession({ isLoggedIn: false, uId: null, roles: [], isLoading: false });
      setUId(null);
      navigateN('/login');
    });
  }, [appConfig.backendUrl, navigateN]);

  // Inactivity Timer (Idle Logout)
  useEffect(() => {
    let timer;
    const resetTimer = () => {
      if (timer) clearTimeout(timer);
      if (session.isLoggedIn) {
        timer = setTimeout(() => {
          logoutF();
        }, 15 * 60 * 1000); // 15 minutes
      }
    };

    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
    events.forEach(event => document.addEventListener(event, resetTimer));

    resetTimer();

    return () => {
      if (timer) clearTimeout(timer);
      events.forEach(event => document.removeEventListener(event, resetTimer));
    };
  }, [logoutF, session.isLoggedIn]);

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          logoutF();
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [logoutF]);

  if (session.isLoading) {
    return <Loader />;
  }

  return (
    <div className="App">
      <Routes>
        <Route path="/" extract element={session.isLoggedIn ? <><Navbar setLoad={setLoad} logoutF={logoutF} setIsImageUploaded={setIsImageUploaded} isNewVendor={isNewVendor} setIsNewVendor={setIsNewVendor} /><Home fileBill={fileBill} setFileBill={setFileBill} isImageUploaded={isImageUploaded} setIsImageUploaded={setIsImageUploaded} BillOCRDetails={BillOCRDetails} setBillOCRDetails={setBillOCRDetails} setBillItems={setBillItems} setisFileTypeImg={setisFileTypeImg} setFullVendorsList={setFullVendorsList} fullVendorsList={fullVendorsList} isNewVendor={isNewVendor} setIsNewVendor={setIsNewVendor} setOCRAddress={setOCRAddress} BillItems={BillItems} handleDelete={handleDelete} addTableRows={addTableRows} onFormBillItemsValueChange={onFormBillItemsValueChange} onFormVChange={onFormVChange} isFileTypeImg={isFileTypeImg} onVendorChange={onVendorChange} isOCRVendor={isOCRVendor} OCRAddress={OCRAddress} load={load} setLoad={setLoad} uId={session.uId} selectedOption={selectedOption} setSelectedOption={setSelectedOption} _onChange={_onChange} selectedOptionAddress={selectedOptionAddress} setSelectedOptionAddress={setSelectedOptionAddress} _onChangeAddress={_onChangeAddress} activeVendor={activeVendor} setActiveVendor={setActiveVendor} activeVendorFull={activeVendorFull} setActiveVendorFull={setActiveVendorFull} /></> : <Login uId={uId} setUId={setUId} fetchMe={fetchMe} />} />
        <Route path="/uploadedDocs" element={session.isLoggedIn ? <><Navbar setLoad={setLoad} logoutF={logoutF} setIsImageUploaded={setIsImageUploaded} isNewVendor={isNewVendor} setIsNewVendor={setIsNewVendor} /><UploadedDocs load={load} setLoad={setLoad} SuplierRender={SuplierRender} uId={session.uId} /> </> : <Login uId={uId} setUId={setUId} fetchMe={fetchMe} />} />
        <Route path="/uploadedDocs/supplier" element={session.isLoggedIn ? <><Navbar setLoad={setLoad} logoutF={logoutF} setIsImageUploaded={setIsImageUploaded} isNewVendor={isNewVendor} setIsNewVendor={setIsNewVendor} /> <Suplier load={load} setLoad={setLoad} currentSupplier={currentSupplier} uId={session.uId} /></> : <Login uId={uId} setUId={setUId} fetchMe={fetchMe} />} />
        <Route path="/uploadedDocs/viewDoc" element={session.isLoggedIn ? <><Navbar setLoad={setLoad} logoutF={logoutF} setIsImageUploaded={setIsImageUploaded} isNewVendor={isNewVendor} setIsNewVendor={setIsNewVendor} /><Docview load={load} setLoad={setLoad} setIsImageUploaded={setIsImageUploaded} uId={session.uId} /></> : <Login uId={uId} setUId={setUId} fetchMe={fetchMe} />} />
        <Route path="/login" element={session.isLoggedIn ? <Navigate to="/" replace /> : <Login uId={uId} setUId={setUId} fetchMe={fetchMe} />} />
        <Route path="/register" element={<SignUp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/pushQB" element={session.isLoggedIn && session.roles.includes("ROLE_QBPUSHUSER") ? <><Navbar setLoad={setLoad} logoutF={logoutF} setIsImageUploaded={setIsImageUploaded} isNewVendor={isNewVendor} setIsNewVendor={setIsNewVendor} /><PushQB load={load} setLoad={setLoad} uId={session.uId} /> </> : <Navigate to="/" replace />} />
        <Route path="/settings" element={session.isLoggedIn && session.roles.includes("ROLE_QBPUSHUSER") ? <><Navbar setLoad={setLoad} logoutF={logoutF} setIsImageUploaded={setIsImageUploaded} isNewVendor={isNewVendor} setIsNewVendor={setIsNewVendor} /><Settings load={load} setLoad={setLoad} uId={session.uId} /> </> : <Navigate to="/" replace />} />
        <Route path="/my-account" element={session.isLoggedIn ? <><Navbar setLoad={setLoad} logoutF={logoutF} setIsImageUploaded={setIsImageUploaded} isNewVendor={isNewVendor} setIsNewVendor={setIsNewVendor} /><MyAccount uId={session.uId} /></> : <Navigate to="/" replace />} />
        <Route path="/download-manager" element={session.isLoggedIn ? <><Navbar setLoad={setLoad} logoutF={logoutF} setIsImageUploaded={setIsImageUploaded} isNewVendor={isNewVendor} setIsNewVendor={setIsNewVendor} /><DownloadManager /></> : <Navigate to="/" replace />} />

      </Routes>
    </div>
  );
}

export default App;
